import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from 'config/config';

import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/ac-customer-api-main.css';
import './assets/css/date-picker.css';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: config.GTMContainerId
}
    
TagManager.initialize(tagManagerArgs)
    
ReactDOM.render( 
    <React.StrictMode >
    <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();